
import thunk from 'redux-thunk'
import createDebounce from 'redux-debounced'
import rootReducer from '../reducers/rootReducer'
import { createStore, applyMiddleware, compose } from 'redux'
import { persistReducer, persistStore } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { encryptTransform } from 'redux-persist-transform-encrypt'

const encryptot = encryptTransform({
    secretKey: 'my-super-secret-key'
})

const persistConfig = {
    key: 'storage-Data',
    storage,
    transforms: [encryptot]
}
// ** init middleware
const middleware = [thunk, createDebounce()]

// ** Dev Tools
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
// ** persist reducer 
const persistedReducer = persistReducer(persistConfig, rootReducer)

// ** Create store
const store = createStore(persistedReducer, {}, composeEnhancers(applyMiddleware(...middleware)))
export const persistor = persistStore(store)
export { store }
